import React from 'react';
import { Card, Collapse, Steps, Typography } from 'antd';
import Link from 'antd/es/typography/Link';

const { Title, Paragraph } = Typography;
const { Panel } = Collapse;

const AccountCreationGuide = () => {
    const csvSteps = [
        {
            title: 'Prepare Your CSV File',
            description:
                'Export your trades from DAS Trader Pro as a CSV file with the required columns: Time, Symb, Side, Price, Qty, Route, Broker, Account, Type, Cloid.'
        },
        {
            title: 'Select Trade Date',
            description:
                "On the import screen, select the date when the trades occurred (DAS Trader Pro exports don't include trade dates)."
        },
        {
            title: 'Upload and Import',
            description:
                'Click "Upload file" to import your trades. The Journal will automatically parse and categorize your trading data.'
        },
        {
            title: 'Watch Tutorial Video',
            description: (
                <span>
                    Learn how to export and import your trades from DAS Trader Pro.{' '}
                    <Link
                        href="https://player.vimeo.com/video/1002080275?title=0&byline=0&portrait=0&badge=0&autopause=0&app_id=58479"
                        target="_blank"
                    >
                        Watch Video Tutorial →
                    </Link>
                </span>
            )
        }
    ];

    const bbtSteps = [
        {
            title: 'Account Registration',
            description: (
                <span>
                    Complete registration with Bear Bull Traders here:{' '}
                    <Link
                        href="https://members.bearbulltraders.com/das-funded-account/"
                        target="_blank"
                    >
                        Bear Bull Traders | DAS Funded Account
                    </Link>
                </span>
            )
        },
        {
            title: 'Automatic Setup',
            description:
                'Your BBT funded account is automatically created and integrated with the Journal.'
        },
        {
            title: 'Start Trading',
            description:
                'Begin trading with your funded capital. All trades are automatically tracked and analyzed.'
        },
        {
            title: 'Trade Upload',
            description:
                'Trades will be uploaded nightly for all trades taken in your BBT Training Account.'
        }
    ];

    const pctSteps = [
        {
            title: 'Enroll in Peak Capital Trading Bootcamp',
            description: (
                <span>
                    Complete enrollment with Peak Capital Trading here:{' '}
                    <Link href="https://www.peakcapitaltrading.com/bootcamp/" target="_blank">
                        Training Bootcamp – Peak Capital Trading
                    </Link>
                </span>
            )
        },
        {
            title: 'Automatic Setup',
            description:
                'Your PCT funded account is automatically created and integrated with the Journal.'
        },
        {
            title: 'Start Trading',
            description:
                'Begin trading with your funded capital. All trades are automatically tracked and analyzed.'
        },
        {
            title: 'Trade Upload',
            description:
                'Trades will be uploaded nightly for all trades taken in your PCT Training Account.'
        }
    ];

    /*
  const personalSteps = [
    {
      title: 'Choose Broker',
      description: 'Select your broker from the supported list or use generic CSV import for unsupported brokers.'
    },
    {
      title: 'Configure Account',
      description: 'Set your account name, timezone, and profit calculation method.'
    },
    {
      title: 'Import Trade Data',
      description: 'Upload your trade logs or connect via API if supported by your broker.'
    }
  ];
  */

    return (
        <Card style={{ marginBottom: '24px' }}>
            <Title level={4}>Account Setup Guide</Title>
            <Paragraph>
                Choose the setup method that matches your trading account type. Each method includes
                step-by-step instructions to get your trading data integrated with the Journal.
            </Paragraph>

            <Collapse accordion>
                <Panel header="DAS Trader Pro CSV Import" key="csv">
                    <Steps direction="vertical" size="small" current={-1} items={csvSteps} />
                </Panel>

                <Panel header="BBT Funded Training Account" key="bbt">
                    <Steps direction="vertical" size="small" current={-1} items={bbtSteps} />
                </Panel>

                <Panel header="PCT Funded Training Account" key="pct">
                    <Steps direction="vertical" size="small" current={-1} items={pctSteps} />
                </Panel>

                {/*
              <Panel header='Connect to Personal Broker Account' key='personal'>
                  <Steps direction='vertical' size='small' current={-1} items={personalSteps} />
              </Panel>
              */}
            </Collapse>
        </Card>
    );
};

export default AccountCreationGuide;
